module.exports = __webpack_public_path__ + "img/erp_service1.e3b8e8a5.png";